const features = [
  {
    icon: "ri-fire-line",
    iconClass: "bg-primary-100 text-primary-600",
    title: "实时热点聚合",
    desc: "聚合微博、短视频、资讯等平台热搜，按热度与时效智能排序，明星动态与热播综艺名场面一目了然。",
  },
  {
    icon: "ri-archive-2-line",
    iconClass: "bg-accent-100 text-accent-700",
    title: "专题深挖合集",
    desc: "把同一事件的来龙去脉整理成时间线专题，前因后果一次讲清，不再被碎片信息牵着走。",
  },
  {
    icon: "ri-search-line",
    iconClass: "bg-secondary-100 text-secondary-800",
    title: "关键词追踪",
    desc: "订阅你关注的人或剧集，相关瓜事第一时间推送，不错过任何一条感兴趣的动态。",
  },
  {
    icon: "ri-bookmark-line",
    iconClass: "bg-primary-100 text-primary-600",
    title: "收藏与断点",
    desc: "重要内容一键收藏，阅读记录云端同步，换设备也不怕进度丢失，随时接着看。",
  },
  {
    icon: "ri-error-warning-line",
    iconClass: "bg-accent-100 text-accent-700",
    title: "来源可溯源",
    desc: "每条瓜事标注信息来源与时间，帮你快速判断可信度，理性看待未经证实的消息。",
  },
  {
    icon: "ri-battery-2-line",
    iconClass: "bg-secondary-100 text-secondary-800",
    title: "省电轻量运行",
    desc: "极致精简的启动加载与后台机制，在保持流畅的同时减少耗电，刷上一整天也不卡顿。",
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full border-y border-background-200 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-10 max-w-2xl text-center md:mb-14">
          <span className="inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-xs font-bold text-primary-700">
            核心功能
          </span>
          <h2 className="mt-4 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            为什么大家都在用吃瓜神器？
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            从聚合、追踪到深挖与阅读，一套顺手的工具，把吃瓜体验拉满。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <div
              key={f.title}
              className="group rounded-lg border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <span
                className={`inline-flex h-11 w-11 items-center justify-center rounded-xl transition-transform group-hover:scale-110 ${f.iconClass}`}
              >
                <i className={`${f.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}